import { useContext, useRef } from "react";

import { useTranslation } from "react-i18next";

import { colors } from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";
import HighlightedOption from "components/HighlightedOption";
import ParamsContext from "context/params/paramsContext";

import { ListCompanyProps } from "../../types";
import ListSectionTitle from "./ListSectionTitle";

const ListCompany = ({ data, query, selectCompany }: ListCompanyProps) => {
    const { gray700 } = colors;
    const { companyFilteredValues } = useContext(ParamsContext);

    const { t } = useTranslation();

    const { id, name, count } = data;

    const companyItemRef = useRef<any>(null);

    const handleClick = () => selectCompany(data);

    const isSelected =
        companyFilteredValues.findIndex(company => company.id === id) !== -1;

    return id === "null" ? (
        <ListSectionTitle ref={companyItemRef}>
            {t(`Dialog##${name}`)} ({count})
        </ListSectionTitle>
    ) : (
        <ListChoice
            ref={companyItemRef}
            title={<HighlightedOption text={name} query={query} />}
            isNormalWhiteSpace
            isCheckbox
            onClick={handleClick}
            selected={isSelected}
            outerStyle={{ "& .MuiMenuItem-root": { color: gray700 } }}
        />
    );
};

export default ListCompany;
